"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgRulerOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M10 20H7V4h3v16zm-3 2a2 2 0 01-2-2V4a2 2 0 012-2h3a2 2 0 012 2v16a2 2 0 01-2 2H7z' }),
    react_1.default.createElement("path", { d: 'M8 14h2v-1H8v1zM9 12h1v-1H9v1zM9 20h1v-1H9v1zM8 10h2V9H8v1zM8 18h2v-1H8v1zM8 6h2V5H8v1zM9 8h1V7H9v1zM9 16h1v-1H9v1zM14 2h6v2h-2v16h2v2h-6v-2h2V4h-2V2z' }))); };
exports.default = SvgRulerOutline;
//# sourceMappingURL=RulerOutline.js.map